import Dexie from 'dexie';

const db = new Dexie('AveData');
// Schema
/*

todos {
  id: ID,
  creationDate: Number / Date
  done: Number,
  donetime: Number,
  label: String,
  project: ID ? Brauchen wir das?
  title: String,
  time: Number,
  tracking: Boolean,
  startTracking: Number/ Date,
  endTracking: Number/ Date,
}


projects {
  id: ID
  title: String
  duration: Number, Hier wird die getrackte Zeit aller Todos summiert.
  time: Number, Hier wird die Summe aller Todos betrachtet
}

config {
  name: String,
  hideFinishedTodos: Boolean,
  roundingFactor: Number,
}

Labels {
  id: ID,
  title: String,
  duration: Number.
  averageDuratiom: Number,
}

days {
  id: ID
  date: Number/date
  time: Number,
  projects: ID
}
*/


db.version(1).stores({
  todos: '++id, title, time, donetime, creationDate, label, done, tracking, startTracking, endTracking, projectId',
  projects: '++id, title',
  labels: '++id, title, duration, averageDuration',
  config: 'name',
});

export default db;
